exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'CustomLato';\n  src: url(" + require("../assets/fonts/Lato/Lato-Regular.ttf") + "); }\n\nhtml, body, #root {\n  height: 100%;\n  font-family: 'CustomLato'; }\n\n.full-height {\n  height: 100%; }\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif; }\n\n.container-with-top-menu {\n  height: calc(100% - 65px);\n  background-color: #F5F5F5;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/index.scss
// module id = 679
// module chunks = 0